import { Component, OnInit } from '@angular/core';
import {
	AbstractControl,
	UntypedFormBuilder,
	UntypedFormGroup,
	Validators,
	ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ILayoutState } from '@layout/state/layout.reducer';
import { roomTypesList } from '@layout/state/layout.selectors';
import { first, map, pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { IOption } from '@shared/interfaces/selectable-options.interfaces';
import { ITenant } from '@app/pages/settings/portfolio/interfaces/area-assets.interfaces';
import { GetOrganizationsQuery } from '@app/pages/settings/portfolio/graphql/assets-graphql.queries';
import { RoomTypeTranslationKeys } from '@app/pages/digital-twin/configs/room-types-mapping';
import { MatIcon } from '@angular/material/icon';
import { MatRipple, MatOption } from '@angular/material/core';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSelect } from '@angular/material/select';
import { AuTechnoBtnComponent } from '../../../shared/ui-components/au-techno-btn/au-techno-btn.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	templateUrl: './add-room.component.html',
	styleUrls: ['./add-room.component.scss'],
	imports: [
		MatIcon,
		MatDialogClose,
		MatRipple,
		ReactiveFormsModule,
		MatFormField,
		MatInput,
		MatError,
		MatProgressSpinner,
		MatSelect,
		MatOption,
		AuTechnoBtnComponent,
		NgxTolgeeModule,
	],
})
export class AddRoomComponent implements OnInit {
	roomTypes: IOption[] = [];
	availableTenants: ITenant[] = [];
	form: UntypedFormGroup;
	roomTypeTranslationKeys = RoomTypeTranslationKeys;

	constructor(
		private dialogRef: MatDialogRef<AddRoomComponent>,
		private fb: UntypedFormBuilder,
		private store$: Store<ILayoutState>,
		private apollo: Apollo
	) {
		this.form = this.fb.group({
			roomName: ['', Validators.required],
			roomType: [''],
			roomTenant: '',
		});
	}

	ngOnInit() {
		this.store$
			.select(roomTypesList)
			.pipe(first(hasValue => !!hasValue))
			.subscribe(roomTypes => {
				this.roomTypes = roomTypes;
				this.form.patchValue({
					roomType: roomTypes[0].id,
				});
			});
		this.loadTenantOptions();
	}

	loadTenantOptions() {
		return this.apollo
			.query<ITenant[]>({
				query: GetOrganizationsQuery,
				variables: {
					// TODO need move to constant
					organizationType: ['tenant'],
				},
				fetchPolicy: 'network-only',
			})
			.pipe(
				pluck('data', 'organizations'),
				map((tenants: ITenant[]) => tenants.filter(Boolean))
			)
			.subscribe(tenants => {
				this.availableTenants = tenants;
			});
	}

	addApproved() {
		this.dialogRef.close(this.form.value);
	}

	get roomNameControl(): AbstractControl {
		return this.form.controls.roomName;
	}
}
